/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_TCR_PORT_ADMIN_LIST,
  GET_TCR_PORT_ADMIN_LIST_SUCCESS,
  GET_TCR_PORT_ADMIN_LIST_ERROR,
  GET_TCR_PORT_ADMIN_NOTES,
  GET_TCR_PORT_ADMIN_NOTES_SUCCESS,
  GET_TCR_PORT_ADMIN_NOTES_ERROR,
  CREATE_TCR_PORT_ADMIN_NOTE,
  CREATE_TCR_PORT_ADMIN_NOTE_SUCCESS,
  CREATE_TCR_PORT_ADMIN_NOTE_ERROR,
  UPDATE_TCR_PORT_ADMIN_NOTE,
  UPDATE_TCR_PORT_ADMIN_NOTE_SUCCESS,
  UPDATE_TCR_PORT_ADMIN_NOTE_ERROR,
  DELETE_TCR_PORT_ADMIN_NOTE,
  DELETE_TCR_PORT_ADMIN_NOTE_SUCCESS,
  DELETE_TCR_PORT_ADMIN_NOTE_ERROR,
} from 'src/actions/tcrPortAdminActions';

// CON-1569 — combined TCR + Port admin slice.
//
// notesBySalespersonId caches each expand-row's notes so re-expanding a
// row does not refetch unless a note was just added (the create thunk
// re-dispatches the fetch).

const initialState = {
  listLoading: false,
  listError: null,
  rows: [],
  total: 0,
  noteAuthors: [],
  tcrStatusOptions: [],
  portStatusOptions: [],
  notesBySalespersonId: {},
  notesLoadingBySalespersonId: {},
  noteSaving: false,
};

const tcrPortAdminReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_TCR_PORT_ADMIN_LIST: {
      return produce(state, (draft) => {
        draft.listLoading = true;
        draft.listError = null;
      });
    }

    case GET_TCR_PORT_ADMIN_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.listLoading = false;
        draft.rows = Array.isArray(payload?.rows) ? payload.rows : [];
        draft.total = payload?.total || 0;
        draft.noteAuthors = Array.isArray(payload?.noteAuthors) ? payload.noteAuthors : [];
        draft.tcrStatusOptions = Array.isArray(payload?.tcrStatusOptions) ? payload.tcrStatusOptions : [];
        draft.portStatusOptions = Array.isArray(payload?.portStatusOptions) ? payload.portStatusOptions : [];
      });
    }

    case GET_TCR_PORT_ADMIN_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.listLoading = false;
        draft.listError = payload?.error || 'Failed to load TCR registrations';
        draft.rows = [];
        draft.total = 0;
      });
    }

    case GET_TCR_PORT_ADMIN_NOTES: {
      return produce(state, (draft) => {
        draft.notesLoadingBySalespersonId[payload.salespersonId] = true;
      });
    }

    case GET_TCR_PORT_ADMIN_NOTES_SUCCESS: {
      return produce(state, (draft) => {
        draft.notesLoadingBySalespersonId[payload.salespersonId] = false;
        draft.notesBySalespersonId[payload.salespersonId] = Array.isArray(payload?.notes)
          ? payload.notes
          : [];
      });
    }

    case GET_TCR_PORT_ADMIN_NOTES_ERROR: {
      return produce(state, (draft) => {
        if (payload?.salespersonId) {
          draft.notesLoadingBySalespersonId[payload.salespersonId] = false;
        }
      });
    }

    case CREATE_TCR_PORT_ADMIN_NOTE:
    case UPDATE_TCR_PORT_ADMIN_NOTE:
    case DELETE_TCR_PORT_ADMIN_NOTE: {
      return produce(state, (draft) => {
        draft.noteSaving = true;
      });
    }

    case CREATE_TCR_PORT_ADMIN_NOTE_SUCCESS:
    case CREATE_TCR_PORT_ADMIN_NOTE_ERROR:
    case UPDATE_TCR_PORT_ADMIN_NOTE_SUCCESS:
    case UPDATE_TCR_PORT_ADMIN_NOTE_ERROR:
    case DELETE_TCR_PORT_ADMIN_NOTE_SUCCESS:
    case DELETE_TCR_PORT_ADMIN_NOTE_ERROR: {
      return produce(state, (draft) => {
        draft.noteSaving = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default tcrPortAdminReducer;
